import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";

const FilterControl = ({ applyEnabled, onApply, onCancel, onReset }) => {
  return (
    <div className="d-flex align-items-center justify-content-between">
      <div>
        {onReset &&
        <Button data-id="filter-reset" color="link" className="p-0" onClick={onReset}>
          Reset Filter
        </Button>}
      </div>
      <div>
        <Button data-id="filter-cancel" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button data-id="filter-apply" color="primary" type="submit" disabled={!applyEnabled} className="ml-1" onClick={onApply}>
          Apply
        </Button>
      </div>
    </div>
  );
};

FilterControl.propTypes = {
  onApply: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  applyEnabled: PropTypes.bool
};

FilterControl.defaultProps = {
  applyEnabled: false
};

export default FilterControl;
